export default __webpack_public_path__ + "static/media/ContactManagerApp.89d23675.png";